import useFetchLead from 'components/domain/lead/useFetchLead';
import useAppUser from 'hooks/useAppUser';

const leadGqlFields = `
  checkInDateTimeString,
  email,
  firstName,
  lastName,
  uid,
`;

const useFetchLeadForLeadCell = ({ leadUid }: { leadUid: string }) => {
  const { agencyUid } = useAppUser();

  return useFetchLead({
    enabled: !!agencyUid,
    fields: leadGqlFields,
    leadUid,
  });
};

export default useFetchLeadForLeadCell;
